

export function button17_click(event) {
    $w('#annoucement').collapse();
	// Add your code for this event here: 
}